if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"omk","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(068|264|567|681|866)|2(69[57]|7(15|3|81)|(01|32|38)7|862)|5([38]08|076|41)|6(018|35|531|587|681)|7((30|33|96)7|729|769)|8(145|609|611|955)|329|387|415|9080|9198)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}